import { MemberAvatars } from "@components/common/member/member-avatars";
import { projectMembersSelector } from "@store/projects/projects-selector";
import { useAppSelector } from "@store/store-helper";
import { getPrettyName } from "@utils/user-utils";

/**
 * Shows the details regarding project members
 */
export function MemberDetails(): JSX.Element {
  const projectMembers = useAppSelector(projectMembersSelector);

  // Show the project members sorted by name
  const sortedProjectMembers = [...projectMembers].sort((a, b) =>
    getPrettyName(a).localeCompare(getPrettyName(b))
  );

  return (
    <MemberAvatars
      label="Project Members"
      members={sortedProjectMembers}
      maxMemberAvatars={4}
    />
  );
}
